"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPLocalStorage = void 0;
/**
 * Componente não visual PPLocalStorage
 * Utilização do window.localStorage
 */
exports.PPLocalStorage = {
    //Chave local 
    key: '',
    /**
     * Inicialização do componente com a chave local
     * @param key chave local
     */
    init: function (key) {
        this.key = key;
    },
    /**
     * Carregar os valores do item de acordo com a chave local
     * @returns JSON
     */
    load: function () {
        var item = window.localStorage.getItem(this.key);
        if (item)
            return JSON.parse(item);
        else
            return null;
    },
    /**
     * Salvar os valores do item de acordo com a chave local
     * @param data Valores do item - tipo JSON
     */
    save: function (data) {
        window.localStorage.setItem(this.key, JSON.stringify(data));
    },
    /**
     * Limpa o conteúdo do localStorage
     */
    reset: function () {
        window.localStorage.clear();
    }
};
